import { render, staticRenderFns } from "./card-replace.vue?vue&type=template&id=4407a209&"
import script from "./card-replace.vue?vue&type=script&lang=js&"
export * from "./card-replace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports